import Http from "../utilities/Http";
import {API_ROOT} from "../config";

export default {
	async getIntegrations() {
		let response = await Http().get(API_ROOT + '/integrations/');

		return response.data.integrations;
	},
	async getIntegration(id) {
		let response = await Http().get(API_ROOT + '/integrations/' + id);

		return response.data.integration;
	},
	async getOrganizationApiKey(organizationId) {
		let response = await Http().get(API_ROOT + '/integrations/get-organization-api-key/' + organizationId);

		return response.data.apiKey;
	},
	async setOrganizationTextlineEnabled(organizationId, value) {
		let response = await Http().post(
			API_ROOT + '/integrations/set-organization-textline-enabled/' + organizationId,
			{ enabled: value }
		);

		return response.data;
	},
	async setOrganizationTwilioEnabled(organizationId, value) {
		let response = await Http().post(
			API_ROOT + '/integrations/set-organization-twilio-enabled/' + organizationId,
			{ enabled: value }
		);

		return response.data;
	},
	async getOrganizationTextlineGroups(organizationId, token) {
		let response = await Http().post(
			API_ROOT + '/integrations/get-organization-textline-groups/' + organizationId,
			{ token }
		);

		return response.data.groups;
	},
	async getOrganizationTwilioNumbers(organizationId, token, sid) {
		let response = await Http().post(
			API_ROOT + '/integrations/get-organization-twilio-numbers/' + organizationId,
			{ token, sid }
		);

		return response.data.numbers;
	},
	async setOrganizationTextlineGroup(organizationId, groupUUID) {
		let response = await Http().post(
			API_ROOT + '/integrations/set-organization-textline-group/' + organizationId,
			{ group: groupUUID }
		);

		return response.data;
	},
	async setOrganizationTwilioNumber(organizationId, numberSID, phoneNumber = null) {
		let response = await Http().post(
			API_ROOT + '/integrations/set-organization-twilio-number/' + organizationId,
			{ numberSID, phoneNumber }
		);

		return response.data;
	},
	async setOrganizationTextlineToken(organizationId, token) {
		let response = await Http().post(
			API_ROOT + '/integrations/set-organization-textline-token/' + organizationId,
			{ token }
		);

		return response.data;
	},
	async setOrganizationTwilioToken(organizationId, token) {
		let response = await Http().post(
			API_ROOT + '/integrations/set-organization-twilio-token/' + organizationId,
			{ token }
		);

		return response.data;
	},
	async setOrganizationTwilioSid(organizationId, sid) {
		let response = await Http().post(
			API_ROOT + '/integrations/set-organization-twilio-sid/' + organizationId,
			{ sid }
		);

		return response.data;
	},
	async getOrganizationTextlineGroup(organizationId) {
		let response = await Http().get(
			API_ROOT + '/integrations/get-organization-textline-group/' + organizationId,
		);

		return response.data;
	},
	async setOrganizationZapierToken(organizationId, token) {
		let response = await Http().post(
			API_ROOT + '/integrations/set-organization-zapier-token/' + organizationId,
			{ token }
		);

		return response.data;
	},
	async setOrganizationZapierEnabled(organizationId, value) {
		let response = await Http().post(
			API_ROOT + '/integrations/set-organization-zapier-enabled/' + organizationId,
			{ enabled: value }
		);

		return response.data;
	},
	async getOrganizationZapierConfiguration(organizationId) {
		let response = await Http().get(
			API_ROOT + '/integrations/get-organization-zapier-configuration/' + organizationId,
		);

		return response.data;
	},
	async setOrganizationZapierConfiguration(organizationId, formData) {
		let response = await Http().post(
			API_ROOT + '/integrations/set-organization-zapier-configuration/' + organizationId, formData, {
				headers: {
					'Content-Type': 'multipart/form-data',
				}
			}
		);

		return response.data;
	},
	async getOrganizationShippingConfig(organizationId) {
		let response = await Http().get(
			API_ROOT + '/integrations/get-organization-shipping-config/' + organizationId,
		);
		return response.data;
	},
	async setOrganizationShippingConfig(organizationId, value) {
		let response = await Http().post(
			API_ROOT + '/integrations/set-organization-shipping-config/' + organizationId,
			{ config: value }
		);

		return response.data;
	},
};
